import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Module = (function() {
  function GetAll() {
    if (logComponent('Module')) { console.debug('Module GetAll'); }
    return axios.get('api/Module/GetAll', getConfig());
  }

  function GetAllForCurrentUser(monitoredIndividualId) {
    if (logComponent('Module')) { console.debug('Module GetAllForCurrentUser'); }
    let params = {};
    if (monitoredIndividualId) params = { monitoredIndividualId };

    return axios.get('api/Module/GetAllForCurrentUser', getConfig( params));
  }

  function GetAllForGroupType(groupTypeEnum) {
    if (logComponent('Module')) { console.debug('Module GetAllForGroupType'); }
    const params = { groupTypeEnum };
    return axios.get('api/Module/GetAllForGroupType', getConfig( params));
  }

  function GetGroupTypePermissions(moduleId) {
    if (logComponent('Module')) { console.debug('Module GetGroupTypePermissions'); }
    const params = { moduleId };
    return axios.get('api/Module/GetGroupTypePermissions', getConfig( params));
  }

  function GetGroups(moduleId) {
    if (logComponent('Module')) { console.debug('Module GetGroups'); }
    const params = { moduleId };
    return axios.get('api/Module/GetGroups', getConfig( params));
  }

  function AddToGroupType(moduleId, groupTypeId) {
    if (logComponent('Module')) { console.debug('Module AddToGroupType'); }
    const data = { moduleId, groupTypeId };
    return axios.post('api/Module/AddToGroupType', data, getConfig());
  }

  function SetGroups(moduleId, groupIds) {
    if (logComponent('Module')) { console.debug('Module SetGroups'); }
    const data = { moduleId, groupIds };
    return axios.put('api/Module/SetGroups', data, getConfig());
  }

  function RemoveFromGroupType(moduleId, groupTypeId) {
    if (logComponent('Module')) { console.debug('Module RemoveFromGroupType'); }
    const data = {moduleId, groupTypeId };
    return axios.delete('api/Module/RemoveFromGroupType', getConfig( null, data));
  }

  return {
    GetAll,
    GetAllForCurrentUser,
    GetAllForGroupType,
    GetGroupTypePermissions,
    GetGroups,
    AddToGroupType,
    SetGroups,
    RemoveFromGroupType
  }
})();

export default Module;